import { GiftCardIcon } from '@grupoboticario/flora-react-icons';
import { Reward as RewardProp } from 'core/domains/checkout';
import { ToolTip } from 'ui/components/compounds/Tooltip';
import { Icon, Tag } from 'ui/components/primitives';
import { placeholderImg } from 'ui/components/primitives/Image/Picture/Picture';
import { arrayGroupBy } from 'ui/utilities/helpers/array-group-by';

import Item from './Item';
import { SUMMARY_COMPONENTS_CONST } from './Summary.components.d';
import { Items, Reward } from './Summary.components.styles';

import type { SelectedPromotion, SelectedPromotionItem } from 'core/services/bff';

type TRewardsBase = {
  rewards: RewardProp;
  selectedPromotions: SelectedPromotion[];
};

const RewardsBase = ({ rewards, selectedPromotions }: TRewardsBase) => {
  if (!rewards && !selectedPromotions.length) {
    return null;
  }

  const { discounts = [], gifts = [] } = rewards;

  if (!discounts.length && !gifts.length && !selectedPromotions.length) {
    return <div data-testid={SUMMARY_COMPONENTS_CONST.REWARDS_TEST_ID} />;
  }

  const hasNextOrderAllowed = selectedPromotions.find((promotion) => promotion.nextOrderAllowed);

  const promotionItens = selectedPromotions.flatMap(
    (promotion) => promotion.rewards,
  ) as unknown as SelectedPromotionItem[];
  const itensBySku = arrayGroupBy(promotionItens, 'sku');
  const agroupedByQuantity = [] as SelectedPromotionItem[];

  Object.keys(itensBySku).forEach((key) =>
    agroupedByQuantity.push({
      sku: key,
      name: itensBySku[key][0].name,
      images: itensBySku[key][0].images,
      quantity: itensBySku[key].reduce(
        (acc: number, item: SelectedPromotionItem) => acc + item.quantity,
        0,
      ),
    }),
  );

  gifts?.forEach((gift) => {
    const found = agroupedByQuantity.find((selected) => selected.sku === gift.productCode);

    if (found) {
      found.quantity += gift.quantity;
      return;
    }

    agroupedByQuantity.push({
      sku: gift.productCode,
      name: gift.name,
      images: [gift.image],
      quantity: gift.quantity,
    });
  });

  return (
    <Reward.Component data-testid={SUMMARY_COMPONENTS_CONST.REWARDS_TEST_ID}>
      <Reward.Title>
        <GiftCardIcon size={24} />
        Brindes e descontos
      </Reward.Title>
      {hasNextOrderAllowed && (
        <Reward.NextOrderAllowedMsg>
          Caso os itens fiquem indisponíveis, eles serão enviados em compras futuras
        </Reward.NextOrderAllowedMsg>
      )}

      {agroupedByQuantity.map((item: SelectedPromotionItem) => (
        <Items.Card key={item.sku} radius="rounded">
          <Item
            image={item.images[0] || placeholderImg}
            name={item.name}
            priceTotal={'Grátis'}
            productCode={item.sku}
            quantity={item.quantity}
          />
        </Items.Card>
      ))}

      {discounts.map(({ code, description, name }) => (
        <Reward.Card key={code} radius="rounded">
          <Reward.Info>
            <Tag variant="reward" tab-index={0}>
              Desconto
            </Tag>
            <Reward.Text tab-index={0}>{name}</Reward.Text>
            <ToolTip
              align="center"
              content={`Detalhes da promoção: ${description}`}
              customIcon="discount"
              withIcon
            >
              <Icon.Info size="m" />
            </ToolTip>
          </Reward.Info>
        </Reward.Card>
      ))}
    </Reward.Component>
  );
};

export default RewardsBase;
